// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-card {
  width: 100%;
  min-height: calc(100vh - 290px);
  height: 100%;
  gap: 40px;
  border-radius: 10px;
  box-shadow: -4px 4px 30px 0px rgba(0, 0, 0, 0.04);
}
@media (max-width: 992px) {
  .plan-card {
    min-height: auto;
  }
}
.plan-card .card-body {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 5px;
  padding: 35px;
}
@media (max-width: 767px) {
  .plan-card .card-body {
    padding: 28px 30px;
  }
}
.plan-card .card-body .plan-data {
  width: 100%;
}
.plan-card .card-body .plan-data .sub {
  color: #767676;
}
.plan-card .card-body .plan-data h4 {
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
}
.plan-card .card-body .plan-data p {
  font-weight: 500;
  font-size: 12px;
  margin: 5px 0 10px;
  line-height: normal;
}
.plan-card .card-body .plan-data ul li {
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  line-height: normal;
  display: flex;
  gap: 10px;
  align-items: start;
  margin: 0 0 6px;
}
.plan-card .card-body .plan-data ul li .active svg {
  color: #ece63d;
}
.plan-card .card-body .plan-data ul li .default svg {
  color: #113b65;
}
.plan-card .card-body .plan-data h2 {
  font-weight: 700;
  font-size: 40px;
  line-height: normal;
}
.plan-card .card-body .plan-data button {
  font-weight: 600;
  font-size: 12px;
  line-height: normal;
  text-align: center;
  border-radius: 5px;
  padding: 15px;
  margin: 25px 0 15px;
}
.plan-card.dark-bgcolor {
  background-color: #113b65;
  color: #fff;
  border: 1px solid #113b65;
}
.plan-card.dark-bgcolor h4 {
  color: #fff;
}
.plan-card.dark-bgcolor button {
  color: #113b65;
  background: #fff;
  border-color: #fff;
}
.plan-card.dark-bgcolor h2 {
  color: #fff;
}
.plan-card.light-bgcolor {
  background-color: #fff;
  color: #656565;
  border: 1px solid #ececec;
}
.plan-card.light-bgcolor h4 {
  color: #000000;
}
.plan-card.light-bgcolor h2 {
  color: #113b65;
}
.plan-card.light-bgcolor button {
  color: #113b65;
  background-color: #ece63d;
  border-color: #ece63d;
}
.plan-card.light-bgcolor ul li {
  color: #656565;
}

.footer-sec {
  max-width: 863px;
  margin: 0 auto;
  text-align: center;
  color: #4f4f4f;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}
.footer-sec span {
  font-weight: 600;
}
.footer-sec a {
  color: #0c5298;
  text-decoration: underline;
}

.plan-badge {
  width: 99px;
  height: 21px;
  border-radius: 2px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plan-badge.free {
  background-color: #ece63d;
  color: #113b65;
}
.plan-badge.paid {
  background-color: #113b65;
  color: #ece63d;
}

.stripe-field {
  padding: 10px 12px;
  border: 1px solid #ccd0d5;
  border-radius: 6px;
  background-color: white;
  margin-top: 4px;
}

.stripe-field:hover {
  border-color: #2684ff;
}

.public-plan.main-content {
  margin-left: 0;
}

.bill-details {
  background-color: #f3f3f3;
}

.text-grey {
  color: rgba(17, 17, 17, 0.6);
}

.bg-grey {
  background-color: #e2e2e2;
  color: #113b65;
}

.current-tag {
  border-radius: 0 0 12px 12px;
  background: #ece63d;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  color: #113b65;
  padding: 11px 18px;
  text-align: center;
  text-transform: capitalize;
  position: absolute;
  top: -1px;
  max-width: 177px;
  width: 100%;
  left: 0;
  right: 0;
  display: block;
  margin: 0 auto;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/themes/DYHAC/app/modules/plan/plan.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,+BAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,iDAAA;AACF;AAAE;EAPF;IAQI,gBAAA;EAGF;AACF;AAFE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AAIJ;AAHI;EALF;IAMI,kBAAA;EAMJ;AACF;AALI;EACE,WAAA;AAON;AANM;EACE,cAAA;AAQR;AANM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAQR;AANM;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAQR;AALQ;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAOV;AALY;EACE,cAAA;AAOd;AAHY;EACE,cAAA;AAKd;AAAM;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AAER;AAAM;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAER;AAEE;EACE,yBAAA;EACA,WAAA;EACA,yBAAA;AAAJ;AACI;EACE,WAAA;AACN;AACI;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AACN;AACI;EACE,WAAA;AACN;AAEE;EACE,sBAAA;EACA,cAAA;EACA,yBAAA;AAAJ;AACI;EACE,cAAA;AACN;AACI;EACE,cAAA;AACN;AACI;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AACN;AAEM;EACE,cAAA;AAAR;;AAMA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAHF;AAIE;EACE,gBAAA;AAFJ;AAIE;EACE,cAAA;EACA,0BAAA;AAFJ;;AAMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;AAKE;EACE,yBAAA;EACA,cAAA;AAHJ;AAME;EACE,yBAAA;EACA,cAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AALF;;AAOA;EACE,qBAAA;AAJF;;AAMA;EACE,cAAA;AAHF;;AAKA;EACE,yBAAA;AAFF;;AAIA;EACE,4BAAA;AADF;;AAGA;EACE,yBAAA;EACA,cAAA;AAAF;;AAGA;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAAF","sourcesContent":[".plan-card {\n  width: 100%;\n  min-height: calc(100vh - 290px);\n  height: 100%;\n  gap: 40px;\n  border-radius: 10px;\n  box-shadow: -4px 4px 30px 0px rgba(0, 0, 0, 0.04);\n  @media (max-width: 992px) {\n    min-height: auto;\n  }\n  .card-body {\n    font-size: 13px;\n    font-weight: 500;\n    margin-bottom: 5px;\n    padding: 35px;\n    @media (max-width: 767px) {\n      padding: 28px 30px;\n    }\n    .plan-data {\n      width: 100%;\n      .sub {\n        color: #767676;\n      }\n      h4 {\n        font-size: 18px;\n        font-weight: 600;\n        line-height: normal;\n      }\n      p {\n        font-weight: 500;\n        font-size: 12px;\n        margin: 5px 0 10px;\n        line-height: normal;\n      }\n      ul {\n        li {\n          text-align: left;\n          font-weight: 600;\n          font-size: 12px;\n          line-height: normal;\n          display: flex;\n          gap: 10px;\n          align-items: start;\n          margin: 0 0 6px;\n          .active {\n            svg {\n              color: #ece63d;\n            }\n          }\n          .default {\n            svg {\n              color: #113b65;\n            }\n          }\n        }\n      }\n      h2 {\n        font-weight: 700;\n        font-size: 40px;\n        line-height: normal;\n      }\n      button {\n        font-weight: 600;\n        font-size: 12px;\n        line-height: normal;\n        text-align: center;\n        border-radius: 5px;\n        padding: 15px;\n        margin: 25px 0 15px;\n      }\n    }\n  }\n  &.dark-bgcolor {\n    background-color: #113b65;\n    color: #fff;\n    border: 1px solid #113b65;\n    h4 {\n      color: #fff;\n    }\n    button {\n      color: #113b65;\n      background: #fff;\n      border-color: #fff;\n    }\n    h2 {\n      color: #fff;\n    }\n  }\n  &.light-bgcolor {\n    background-color: #fff;\n    color: #656565;\n    border: 1px solid #ececec;\n    h4 {\n      color: #000000;\n    }\n    h2 {\n      color: #113b65;\n    }\n    button {\n      color: #113b65;\n      background-color: #ece63d;\n      border-color: #ece63d;\n    }\n    ul {\n      li {\n        color: #656565;\n      }\n    }\n  }\n}\n\n.footer-sec {\n  max-width: 863px;\n  margin: 0 auto;\n  text-align: center;\n  color: #4f4f4f;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: normal;\n  span {\n    font-weight: 600;\n  }\n  a {\n    color: #0c5298;\n    text-decoration: underline;\n  }\n}\n\n.plan-badge {\n  width: 99px;\n  height: 21px;\n  border-radius: 2px;\n  font-weight: 600;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &.free {\n    background-color: #ece63d;\n    color: #113b65;\n  }\n\n  &.paid {\n    background-color: #113b65;\n    color: #ece63d;\n  }\n}\n\n.stripe-field {\n  padding: 10px 12px;\n  border: 1px solid #ccd0d5;\n  border-radius: 6px;\n  background-color: white;\n  margin-top: 4px;\n}\n.stripe-field:hover {\n  border-color: #2684ff;\n}\n.public-plan.main-content {\n  margin-left: 0;\n}\n.bill-details {\n  background-color: #f3f3f3;\n}\n.text-grey {\n  color: #11111199;\n}\n.bg-grey {\n  background-color: #e2e2e2;\n  color: #113b65;\n}\n\n.current-tag {\n  border-radius: 0 0 12px 12px;\n  background: #ece63d;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  color: #113b65;\n  padding: 11px 18px;\n  text-align: center;\n  text-transform: capitalize;\n  position: absolute;\n  top: -1px;\n  max-width: 177px;\n  width: 100%;\n  left: 0;\n  right: 0;\n  display: block;\n  margin: 0 auto;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
